module.exports = __webpack_public_path__ + "static/media/waic-today-finish.64a65388.png";